import { OperationParameter, OperationURLParameter } from "@azure/core-client";

export const accept: OperationParameter = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "application/json",
    isConstant: true,
    serializedName: "Accept",
    type: {
      name: "String"
    }
  }
};

export const $host: OperationURLParameter = {
  parameterPath: "$host",
  mapper: {
    serializedName: "$host",
    required: true,
    type: {
      name: "String"
    }
  },
  skipEncoding: true
};

export const openIDToken: OperationParameter = {
  parameterPath: "openIDToken",
  mapper: {
    serializedName: "openIDToken",
    required: true,
    type: {
      name: "String"
    }
  }
};

export const orderNumber: OperationURLParameter = {
  parameterPath: "orderNumber",
  mapper: {
    serializedName: "orderNumber",
    required: true,
    type: {
      name: "String"
    }
  }
};
